export interface CheckoutPlanQuoteInput {
  includedSeats: number;
  monthlyAmountMinor: number;
  annualAmountMinor: number;
}

/** Mirror of server `quotePlan` for checkout display (included-seat catalog amounts). */
export const quoteCheckoutAmountMinor = (
  plan: CheckoutPlanQuoteInput,
  interval: 'monthly' | 'annual',
  seatCount: number,
): number => {
  const base = interval === 'annual' ? plan.annualAmountMinor : plan.monthlyAmountMinor;
  return Math.round((base / plan.includedSeats) * seatCount);
};
